import theme from '../../../style/theme';
import { styled } from 'solid-styled-components';
import { containerQueries } from '../../../tools/check-container-support';

export const StyledEmptyColumnPlaceholder = styled.div`
    ${containerQueries('mobileMax')} {
        display: none;
    }
`;

export const StyledSidePanel = styled.div`
    overflow-y: auto;
    height: 100%;
    padding-block: 4rem;
    padding-left: 7rem;
    margin-right: -100%;
    padding-right: 100%;
    background-color: ${theme.palette.white};
    border-radius: 0 0 5.9rem 5.9rem;
    border-radius: 0 0 0 5rem;
    ${containerQueries('tabletSmallMax')} {
        border-radius: 0 0 3rem 3rem;
        padding-left: 5rem;
    }
    ${containerQueries('mobileMax')} {
        border-radius: 0;
        margin-right: unset;
        padding-left: unset;
        padding-right: unset;
        padding-block: unset;
        padding: 2rem;
    }
`;

export const StyledBottomSection = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 6rem;
    & > button {
        margin-bottom: 2rem;
    }
    ${containerQueries('tabletSmallMax')} {
        align-items: center;
    }
`;

export const StyledButtonsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 2rem;
    ${containerQueries('tabletSmallMax')} {
        justify-content: center;
    }
`;

export const StyledButtonWrapper = styled.div`
    &:not(:last-of-type) {
        margin-right: 2.5rem;
        ${containerQueries('tabletSmallMax')} {
            margin-right: 1rem;
        }
    }
    ${containerQueries('tabletSmallMax')} {
        margin-inline: 1rem;
    }
`;

export const StyledlanguageSelectorOverlay = styled.div`
    container-type: inline-size;
    position: fixed;
    z-index: 11;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: auto;
    overflow-x: hidden;
    -ms-overflow-style: none;  /* IE and Edge */
`;